import { addCurrencyColor } from "../../tools"

export function updateComparisonTable($table, {labels, datasets}) {
  $table.empty()
  addComparisonTableHeader($table, datasets)
  addComparisonTableRowsAndFirstColumn($table, labels)
  addRemainingComparisonColumns($table, datasets)
  addTotalComparisonColumns($table)
}

function addComparisonTableHeader(table, datasets) {
  const $header = $('<thead>')
  const $row = jQuery('<tr>')
  $row.append($('<th>'))
  datasets.forEach(dataset => {
    const $div = $('<div>').addClass('comparison-table__header d-flex flex-nowrap')
    const $legendCircle = $('<div>').addClass('table-legend__box mr-2').css('background-color', '#ccc')
    $legendCircle.css('border-radius', '100%')
    const $headerLabel = $('<span>').text(dataset.label)
    $div.append($legendCircle)
    $div.append($headerLabel)
    $row.append($('<th>').append($div))
  })
  $header.append($row)
  table.append($header)
}

function addComparisonTableRowsAndFirstColumn(table, labels) {
  labels.forEach(label => {
    const $row = $('<tr>')
    $row.append($('<td>').text(label))
    table.append($row)
  })
}

function addRemainingComparisonColumns(table, datasets) {
  datasets.forEach((dataset, idx) => {
    const $th = table.find('th').eq(idx + 1)
    $th.find('.table-legend__box').css('background-color', dataset.backgroundColor)
    dataset.data.forEach((col, index) => {
      const $row = table.find('tr').eq(index + 1)
      const $cell = $('<td>').text(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(col))
      $cell.attr('data-amount', Number(col))
      if (comparisonType() === 'remaining') {
        addCurrencyColor($cell, Number(col))
      }
      $row.append($cell)
    })
  })
}

function addTotalComparisonColumns(table) {
  table.find('thead tr').append($('<th>').text('Total'))
  table.find('tbody tr').each(function() {
    let sum = 0
    const $row = $(this)
    $row.find('td').each(function() {
      sum += Number($(this).data('amount') || 0)
    })
    const $cell = $('<td>').text(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(sum))
    if (comparisonType() === 'remaining') {
      addCurrencyColor($cell, Number(sum))
    }
    $row.append($cell)
  })
}

function comparisonType() {
  const sixMonthViewRefineInput = $('#six-month-view-simple-refine input[type="radio"][name="view-type-toggle"]:checked').val()
  const comparisonRefineInput = $('#comparison-simple-refine input[type="radio"][name="view-type-toggle"]:checked').val()

  return sixMonthViewRefineInput ?? comparisonRefineInput
}
